import { gql } from '@urql/core';

import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';
import { requestUserDataRefresh } from '/src/services/user-data-refresh';

export const setEnabledGaProperties = ({ client }) => ({
  mutationFn: ({ propertyIds }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation SetEnabledGaProperties($propertyIds: [Int!]!) {
          setEnabledGaProperties(propertyIds: $propertyIds) {
            id
          }
        }
      `,
      {
        propertyIds,
      },
    ),
  onSuccess: () => {
    return requestUserDataRefresh().catch(() => {});
  },
});
